import useUser from "../../../api/api-hooks/auth/useUser";
import CloudUsersGroup from "../../../views/cloud/CreateCloudView/CreateCloudGroups/CloudUsersGroup";

const WorkspaceUsersSection = ({ values, onChange }) => {
  const { user, wPermissions } = useUser();

  return (
    <CloudUsersGroup
      values={values}
      usersKey="WorkspaceUsers"
      idKey="id"
      onChange={onChange}
      defaultPermissions={wPermissions}
      permissionsScope="Workspace"
      currentUser={user}
      useExistingUsers
    />
  );
};

export default WorkspaceUsersSection;
